// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
export const emojiTypeAhead = 'emoji-typeahead-element';
export const typeAheadListContainer = 'emoji-typeahead-list-container';

// editor-core is using this static class name for testing
export const typeaheadSelected = 'emoji-typeahead-selected';
